module.exports = __webpack_public_path__ + "img/edgar.0b0663fa.png";